import { render } from "./TrainingDash.vue?vue&type=template&id=56147384&scoped=true"
import script from "./TrainingDash.vue?vue&type=script&lang=js"
export * from "./TrainingDash.vue?vue&type=script&lang=js"

import "./TrainingDash.vue?vue&type=style&index=0&id=56147384&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56147384"]])

export default __exports__